import type { ArticleMedia } from '../types';

// Returns filtered images if on progressive loading enabled.
export const useProgressiveImages = (
  images: ArticleMedia[],
  progressiveLoading: boolean,
  hasInteracted: boolean
): ArticleMedia[] => {
  if (!progressiveLoading || hasInteracted) {
    return images;
  }

  return images.slice(0, 1);
};
